<template>
  <div>
    <TextField
      :placeholder="label"
      @input="$emit('input', $event)"
      :value="value"
      type="number"
      hide-details
      :rules="rules"
    ></TextField>
  </div>
</template>

<script>
export default {
  props: {
    value: [Number, String],
    label: String,
    rules: {
      type: Array,
      default: function () {
        return [];
      },
    },
    links: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped lang="scss"></style>
